import React from 'react';
import { store } from 'state';
import { PageRestricted } from 'pages/errors/page-restricted';

export function AuthenticatedRoute({ action, children }) {
    var userActions = store.getState()?.loggedInUser?.actions;
    var userHasAccess = false;

    if (action == null) {
        userHasAccess = true;
    } else if (userActions != null) {
        var allowedActions = userActions.map((a) => {
            return a.toLowerCase();
        });

        if (Array.isArray(action)) {
            var matchedActions = action.filter(a => allowedActions.includes(a.toLowerCase()));
            userHasAccess = matchedActions.length > 0;
        } else {
            userHasAccess = allowedActions.includes(action.toLowerCase());
        }
    }

    return userHasAccess ? children : <PageRestricted />;
}
